import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import RadioPlayerWrapper from './RadioPlayerWrapper';
import MixcloudPlayer from './MixcloudPlayer';

import withRadioPlayerContext from '../../../context/withRadioPlayerContext';

const RadioContainer = ({
  showRadioPlayer, playerPosition, podcast, ch2, ch1, pageHasPlayer,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisiblePlayer, setVisiblePlayer] = useState(true);
  useEffect(() => {
    setVisiblePlayer(showRadioPlayer);
  }, [showRadioPlayer]);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const closePlayer = () => {
    setVisiblePlayer(false);
  };
  return (
    <>
      { podcast
      ? (
      <div className={`w-full mt-0 trans-opacity fixed ${isOpen ? 'z-top' : 'z-radio'} h-radio ${showRadioPlayer && isVisiblePlayer ? 'bg-radio' : ''} ${playerPosition}`}>
        <MixcloudPlayer />
      </div>
      ) : null
    }
    </>
    // <></>
  );
};


export default withRadioPlayerContext(RadioContainer);
